// إرسال بيانات نموذج التواصل إلى جوجل شيت «عملاء صولا - نموذج الموقع»
// عبر Google Apps Script Web App (ينفَّذ بحساب صاحب الشيت، والوصول: أي شخص)
const SHEET_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbzH_5WF4myQ_xiOLP5UtPQDXnYEITVi4hSui_0Yw1KGLWCM73E_lrOxdpoAAwxY8cl4/exec';

export const sendLeadToSheet = (data = {}) => {
    try {
        const body = new URLSearchParams({
            name: data.name || '',
            phone: data.phone || '',
            email: data.email || '',
            subject: data.subject || '',
            message: data.message || '',
            language: data.language || '',
            source: 'website_contact_form',
        });
        // no-cors: أبس سكربت لا يدعم ترويسات CORS للطلبات المجهولة؛
        // الطلب يصل ويُسجَّل في الشيت وتُتجاهل الاستجابة فقط.
        fetch(SHEET_WEBHOOK_URL, { method: 'POST', mode: 'no-cors', body });
    } catch (e) {
        // فشل الإرسال للشيت يجب ألا يعطّل إرسال النموذج الأساسي
    }
};
